[
  {
    "name" : "ACTINIUM (89), AC-225"
  },
  {
    "name" : "ACTINIUM (89), AC-227"
  },
  {
    "name" : "ACTINIUM (89), AC-228"
  },
  {
    "name" : "ALUMINIUM (13), AL-26"
  },
  {
    "name" : "AMERICIUM (95), AM-241"
  },
  {
    "name" : "AMERICIUM (95), AM-242M"
  },
  {
    "name" : "AMERICIUM (95), AM-243"
  },
  {
    "name" : "ANTIMOON (51), SB-122"
  },
  {
    "name" : "ANTIMOON (51), SB-124"
  },
  {
    "name" : "ANTIMOON (51), SB-125"
  },
  {
    "name" : "ANTIMOON (51), SB-126"
  },
  {
    "name" : "ARGON (18), AR-37"
  },
  {
    "name" : "ARGON (18), AR-39"
  },
  {
    "name" : "ARGON (18), AR-41"
  },
  {
    "name" : "ARSENIC (33), AS-72"
  },
  {
    "name" : "ARSENIC (33), AS-73"
  },
  {
    "name" : "ARSENIC (33), AS-74"
  },
  {
    "name" : "ARSENIC (33), AS-76"
  },
  {
    "name" : "ARSENIC (33), AS-77"
  },
  {
    "name" : "ASTATINE (85), AT-211"
  },
  {
    "name" : "BARIUM (56), BA-131"
  },
  {
    "name" : "BARIUM (56), BA-133"
  },
  {
    "name" : "BARIUM (56), BA-133M"
  },
  {
    "name" : "BARIUM (56), BA-140"
  },
  {
    "name" : "BERKELIUM (97), BK-247"
  },
  {
    "name" : "BERKELIUM (97), BK-249"
  },
  {
    "name" : "BERYLLIUM (4), BE-10"
  },
  {
    "name" : "BERYLLIUM (4), BE-7"
  },
  {
    "name" : "BISMUTH (83), BI-205"
  },
  {
    "name" : "BISMUTH (83), BI-206"
  },
  {
    "name" : "BISMUTH (83), BI-207"
  },
  {
    "name" : "BISMUTH (83), BI-210"
  },
  {
    "name" : "BISMUTH (83), BI-210M"
  },
  {
    "name" : "BISMUTH (83), BI-212"
  },
  {
    "name" : "BROMINE (35), BR-76"
  },
  {
    "name" : "BROMINE (35), BR-77"
  },
  {
    "name" : "BROMINE (35), BR-82"
  },
  {
    "name" : "CADMIUM (48), CD-109"
  },
  {
    "name" : "CADMIUM (48), CD-113M"
  },
  {
    "name" : "CADMIUM (48), CD-115"
  },
  {
    "name" : "CADMIUM (48), CD-115M"
  },
  {
    "name" : "CALCIUM (20), CA-41"
  },
  {
    "name" : "CALCIUM (20), CA-45"
  },
  {
    "name" : "CALCIUM (20), CA-47"
  },
  {
    "name" : "CALIFORNIUM (98), CF-248"
  },
  {
    "name" : "CALIFORNIUM (98), CF-249"
  },
  {
    "name" : "CALIFORNIUM (98), CF-250"
  },
  {
    "name" : "CALIFORNIUM (98), CF-251"
  },
  {
    "name" : "CALIFORNIUM (98), CF-252"
  },
  {
    "name" : "CALIFORNIUM (98), CF-253"
  },
  {
    "name" : "CALIFORNIUM (98), CF-254"
  },
  {
    "name" : "CARBON (6), C-11"
  },
  {
    "name" : "CARBON (6), C-14"
  },
  {
    "name" : "CERIUM (58), CE-139"
  },
  {
    "name" : "CERIUM (58), CE-141"
  },
  {
    "name" : "CERIUM (58), CE-143"
  },
  {
    "name" : "CERIUM (58), CE-144"
  },
  {
    "name" : "CESIUM (55), CS-129"
  },
  {
    "name" : "CESIUM (55), CS-131"
  },
  {
    "name" : "CESIUM (55), CS-132"
  },
  {
    "name" : "CESIUM (55), CS-134"
  },
  {
    "name" : "CESIUM (55), CS-134M"
  },
  {
    "name" : "CESIUM (55), CS-135"
  },
  {
    "name" : "CESIUM (55), CS-136"
  },
  {
    "name" : "CESIUM (55), CS-137"
  },
  {
    "name" : "CHLORINE (17), CL-36"
  },
  {
    "name" : "CHLORINE (17), CL-38"
  },
  {
    "name" : "CHROMIUM (24), CR-51"
  },
  {
    "name" : "COPPER (29), CU-64"
  },
  {
    "name" : "COPPER (29), CU-67"
  },
  {
    "name" : "CURIUM (17), CM-240"
  },
  {
    "name" : "CURIUM (17), CM-241"
  },
  {
    "name" : "CURIUM (17), CM-242"
  },
  {
    "name" : "CURIUM (17), CM-243"
  },
  {
    "name" : "CURIUM (17), CM-244"
  },
  {
    "name" : "CURIUM (17), CM-245"
  },
  {
    "name" : "CURIUM (17), CM-246"
  },
  {
    "name" : "CURIUM (17), CM-247"
  },
  {
    "name" : "CURIUM (17), CM-248"
  },
  {
    "name" : "DYSPROSIUM (66), DY-159"
  },
  {
    "name" : "DYSPROSIUM (66), DY-165"
  },
  {
    "name" : "DYSPROSIUM (66), DY-166"
  },
  {
    "name" : "ERBIUM (68), ER-169"
  },
  {
    "name" : "ERBIUM (68), ER-171"
  },
  {
    "name" : "EUROPIUM (63), EU-147"
  },
  {
    "name" : "EUROPIUM (63), EU-148"
  },
  {
    "name" : "EUROPIUM (63), EU-149"
  },
  {
    "name" : "EUROPIUM (63), EU-150 (LONG-LIVED)"
  },
  {
    "name" : "EUROPIUM (63), EU-150 (SHORT-LIVED)"
  },
  {
    "name" : "EUROPIUM (63), EU-152"
  },
  {
    "name" : "EUROPIUM (63), EU-152M"
  },
  {
    "name" : "EUROPIUM (63), EU-154"
  },
  {
    "name" : "EUROPIUM (63), EU-155"
  },
  {
    "name" : "EUROPIUM (63), EU-156"
  },
  {
    "name" : "FLUORINE (9), F-18"
  },
  {
    "name" : "GADOLINIUM (64), GD-146"
  },
  {
    "name" : "GADOLINIUM (64), GD-148"
  },
  {
    "name" : "GADOLINIUM (64), GD-153"
  },
  {
    "name" : "GADOLINIUM (64), GD-159"
  },
  {
    "name" : "GALLIUM (31), GA-67"
  },
  {
    "name" : "GALLIUM (31), GA-68"
  },
  {
    "name" : "GALLIUM (31), GA-72"
  },
  {
    "name" : "GERMANIUM (32), GE-68"
  },
  {
    "name" : "GERMANIUM (32), GE-71"
  },
  {
    "name" : "GERMANIUM (32), GE-77"
  },
  {
    "name" : "GOLD (79), AU-193"
  },
  {
    "name" : "GOLD (79), AU-194"
  },
  {
    "name" : "GOLD (79), AU-195"
  },
  {
    "name" : "GOLD (79), AU-198"
  },
  {
    "name" : "GOLD (79), AU-199"
  },
  {
    "name" : "HAFNIUM (72), HF-172"
  },
  {
    "name" : "HAFNIUM (72), HF-175"
  },
  {
    "name" : "HAFNIUM (72), HF-181"
  },
  {
    "name" : "HAFNIUM (72), HF-182"
  },
  {
    "name" : "HOLMIUM (67), HO-166"
  },
  {
    "name" : "HOLMIUM (67), HO-166M"
  },
  {
    "name" : "INDIUM (49), IN-111"
  },
  {
    "name" : "INDIUM (49), IN-113M"
  },
  {
    "name" : "INDIUM (49), IN-114M"
  },
  {
    "name" : "INDIUM (49), IN-115"
  },
  {
    "name" : "IRIDIUM (77), IR-189"
  },
  {
    "name" : "IRIDIUM (77), IR-190"
  },
  {
    "name" : "IRIDIUM (77), IR-192"
  },
  {
    "name" : "IRIDIUM (77), IR-194"
  },
  {
    "name" : "IRON (26), FE-52"
  },
  {
    "name" : "IRON (26), FE-55"
  },
  {
    "name" : "IRON (26), FE-59"
  },
  {
    "name" : "IRON (26), FE-60"
  },
  {
    "name" : "KOBALT (27), CO-55"
  },
  {
    "name" : "KOBALT (27), CO-56"
  },
  {
    "name" : "KOBALT (27), CO-57"
  },
  {
    "name" : "KOBALT (27), CO-58"
  },
  {
    "name" : "KOBALT (27), CO-58M"
  },
  {
    "name" : "KOBALT (27), CO-60"
  },
  {
    "name" : "KRYPTON (36), KR-81"
  },
  {
    "name" : "KRYPTON (36), KR-85"
  },
  {
    "name" : "KRYPTON (36), KR-85M"
  },
  {
    "name" : "KRYPTON (36), KR-87"
  },
  {
    "name" : "LANTHANIUM (57), LA-137"
  },
  {
    "name" : "LANTHANIUM (57), LA-140"
  },
  {
    "name" : "LEAD (82), PB-201"
  },
  {
    "name" : "LEAD (82), PB-202"
  },
  {
    "name" : "LEAD (82), PB-203"
  },
  {
    "name" : "LEAD (82), PB-205"
  },
  {
    "name" : "LEAD (82), PB-210"
  },
  {
    "name" : "LEAD (82), PB-212"
  },
  {
    "name" : "LODINE (53), I-124"
  },
  {
    "name" : "LODINE (53), L-123"
  },
  {
    "name" : "LODINE (53), L-125"
  },
  {
    "name" : "LODINE (53), L-126"
  },
  {
    "name" : "LODINE (53), L-129"
  },
  {
    "name" : "LODINE (53), L-131"
  },
  {
    "name" : "LODINE (53), L-132"
  },
  {
    "name" : "LODINE (53), L-133"
  },
  {
    "name" : "LODINE (53), L-134"
  },
  {
    "name" : "LODINE (53), L-135"
  },
  {
    "name" : "LUTETIUM (71), LU-172"
  },
  {
    "name" : "LUTETIUM (71), LU-173"
  },
  {
    "name" : "LUTETIUM (71), LU-174"
  },
  {
    "name" : "LUTETIUM (71), LU-174M"
  },
  {
    "name" : "LUTETIUM (71), LU-177"
  },
  {
    "name" : "MAGNESIUM (12), MG-28"
  },
  {
    "name" : "MANGANESE (25), MN-52"
  },
  {
    "name" : "MANGANESE (25), MN-53"
  },
  {
    "name" : "MANGANESE (25), MN-54"
  },
  {
    "name" : "MANGANESE (25), MN-56"
  },
  {
    "name" : "MERCURY (80), HG-194"
  },
  {
    "name" : "MERCURY (80), HG-195M"
  },
  {
    "name" : "MERCURY (80), HG-197"
  },
  {
    "name" : "MERCURY (80), HG-197M"
  },
  {
    "name" : "MERCURY (80), HG-203"
  },
  {
    "name" : "MOLYBDENUM (42), MO-93"
  },
  {
    "name" : "MOLYBDENUM (42), MO-99"
  },
  {
    "name" : "NEODYMIUM (60), ND-147"
  },
  {
    "name" : "NEODYMIUM (60), ND-149"
  },
  {
    "name" : "NEPTUNIUM (93), NP-235"
  },
  {
    "name" : "NEPTUNIUM (93), NP-236 (LONG-LIVED)"
  },
  {
    "name" : "NEPTUNIUM (93), NP-236 (SHORT-LIVED)"
  },
  {
    "name" : "NEPTUNIUM (93), NP-237"
  },
  {
    "name" : "NEPTUNIUM (93), NP-239"
  },
  {
    "name" : "NICKEL (28), NI-59"
  },
  {
    "name" : "NICKEL (28), NI-63"
  },
  {
    "name" : "NICKEL (28), NI-65"
  },
  {
    "name" : "NIOBIUM (41), NB-93M"
  },
  {
    "name" : "NIOBIUM (41), NB-94"
  },
  {
    "name" : "NIOBIUM (41), NB-95"
  },
  {
    "name" : "NIOBIUM (41), NB-97"
  },
  {
    "name" : "NITROGEN (7), N-13"
  },
  {
    "name" : "OSMIUM (76), OS-185"
  },
  {
    "name" : "OSMIUM (76), OS-191"
  },
  {
    "name" : "OSMIUM (76), OS-191M"
  },
  {
    "name" : "OSMIUM (76), OS-193"
  },
  {
    "name" : "OSMIUM (76), OS-194"
  },
  {
    "name" : "PALLADIUM (46), PD-103"
  },
  {
    "name" : "PALLADIUM (46), PD-107"
  },
  {
    "name" : "PALLADIUM (46), PD-109"
  },
  {
    "name" : "PHOSPHORUS (15), P-32"
  },
  {
    "name" : "PHOSPHORUS (15), P-33"
  },
  {
    "name" : "PLATINUM (78), PT-188"
  },
  {
    "name" : "PLATINUM (78), PT-191"
  },
  {
    "name" : "PLATINUM (78), PT-193"
  },
  {
    "name" : "PLATINUM (78), PT-193M"
  },
  {
    "name" : "PLATINUM (78), PT-195M"
  },
  {
    "name" : "PLATINUM (78), PT-197"
  },
  {
    "name" : "PLATINUM (78), PT-197M"
  },
  {
    "name" : "PLUTONIUM (94), PU-236"
  },
  {
    "name" : "PLUTONIUM (94), PU-237"
  },
  {
    "name" : "PLUTONIUM (94), PU-238"
  },
  {
    "name" : "PLUTONIUM (94), PU-239"
  },
  {
    "name" : "PLUTONIUM (94), PU-240"
  },
  {
    "name" : "PLUTONIUM (94), PU-241"
  },
  {
    "name" : "PLUTONIUM (94), PU-242"
  },
  {
    "name" : "PLUTONIUM (94), PU-244"
  },
  {
    "name" : "POLONIUM (84), PO-210"
  },
  {
    "name" : "POTASSIUM (19), K-40"
  },
  {
    "name" : "POTASSIUM (19), K-42"
  },
  {
    "name" : "POTASSIUM (19), K-43"
  },
  {
    "name" : "PRASEODYMIUM (59), PR-142"
  },
  {
    "name" : "PRASEODYMIUM (59), PR-143"
  },
  {
    "name" : "PROMETHIUM (61), PM-143"
  },
  {
    "name" : "PROMETHIUM (61), PM-144"
  },
  {
    "name" : "PROMETHIUM (61), PM-145"
  },
  {
    "name" : "PROMETHIUM (61), PM-147"
  },
  {
    "name" : "PROMETHIUM (61), PM-148M"
  },
  {
    "name" : "PROMETHIUM (61), PM-149"
  },
  {
    "name" : "PROMETHIUM (61), PM-151"
  },
  {
    "name" : "PROTACTINIUM (91), PA-230"
  },
  {
    "name" : "PROTACTINIUM (91), PA-231"
  },
  {
    "name" : "PROTACTINIUM (91), PA-233"
  },
  {
    "name" : "RADIUM (88), RA-223"
  },
  {
    "name" : "RADIUM (88), RA-224"
  },
  {
    "name" : "RADIUM (88), RA-225"
  },
  {
    "name" : "RADIUM (88), RA-226"
  },
  {
    "name" : "RADIUM (88), RA-228"
  },
  {
    "name" : "RADON (86), RN-222"
  },
  {
    "name" : "RENIUM (75), RE (NAT)"
  },
  {
    "name" : "RENIUM (75), RE-184"
  },
  {
    "name" : "RENIUM (75), RE-184M"
  },
  {
    "name" : "RENIUM (75), RE-186"
  },
  {
    "name" : "RENIUM (75), RE-187"
  },
  {
    "name" : "RENIUM (75), RE-188"
  },
  {
    "name" : "RENIUM (75), RE-189"
  },
  {
    "name" : "RHODIUM (45), RH-101"
  },
  {
    "name" : "RHODIUM (45), RH-102"
  },
  {
    "name" : "RHODIUM (45), RH-102M"
  },
  {
    "name" : "RHODIUM (45), RH-103M"
  },
  {
    "name" : "RHODIUM (45), RH-105"
  },
  {
    "name" : "RHODIUM (45), RH-99"
  },
  {
    "name" : "RUBIDIUM (37), RB (NAT)"
  },
  {
    "name" : "RUBIDIUM (37), RB-81"
  },
  {
    "name" : "RUBIDIUM (37), RB-83"
  },
  {
    "name" : "RUBIDIUM (37), RB-84"
  },
  {
    "name" : "RUBIDIUM (37), RB-86"
  },
  {
    "name" : "RUBIDIUM (37), RB-87"
  },
  {
    "name" : "RUTHENIUM (44), RU-103"
  },
  {
    "name" : "RUTHENIUM (44), RU-105"
  },
  {
    "name" : "RUTHENIUM (44), RU-106"
  },
  {
    "name" : "RUTHENIUM (44), RU-97"
  },
  {
    "name" : "SAMARIUM (62), SM-145"
  },
  {
    "name" : "SAMARIUM (62), SM-147"
  },
  {
    "name" : "SAMARIUM (62), SM-151"
  },
  {
    "name" : "SAMARIUM (62), SM-153"
  },
  {
    "name" : "SCANDIUM (21), SC-44"
  },
  {
    "name" : "SCANDIUM (21), SC-46"
  },
  {
    "name" : "SCANDIUM (21), SC-47"
  },
  {
    "name" : "SCANDIUM (21), SC-48"
  },
  {
    "name" : "SELENIUM (34), SE-75"
  },
  {
    "name" : "SELENIUM (34), SE-79"
  },
  {
    "name" : "SILICIUM (14), SI-31"
  },
  {
    "name" : "SILICIUM (14), SI-32"
  },
  {
    "name" : "SILVER (47), AG-105"
  },
  {
    "name" : "SILVER (47), AG-108M"
  },
  {
    "name" : "SILVER (47), AG-110M"
  },
  {
    "name" : "SILVER (47), AG-111M"
  },
  {
    "name" : "SODIUM (11), NA-22"
  },
  {
    "name" : "SODIUM (11), NA-24"
  },
  {
    "name" : "STRONTIUM (38), SR-82"
  },
  {
    "name" : "STRONTIUM (38), SR-85"
  },
  {
    "name" : "STRONTIUM (38), SR-85M"
  },
  {
    "name" : "STRONTIUM (38), SR-87M"
  },
  {
    "name" : "STRONTIUM (38), SR-89"
  },
  {
    "name" : "STRONTIUM (38), SR-90"
  },
  {
    "name" : "STRONTIUM (38), SR-91"
  },
  {
    "name" : "STRONTIUM (38), SR-92"
  },
  {
    "name" : "SULPHUR (16), S-35"
  },
  {
    "name" : "TANTALIUM (73), TA-178 (LONG-LIVED)"
  },
  {
    "name" : "TANTALIUM (73), TA-179"
  },
  {
    "name" : "TANTALIUM (73), TA-182"
  },
  {
    "name" : "TECHNETIUM (43), TC-95M"
  },
  {
    "name" : "TECHNETIUM (43), TC-96"
  },
  {
    "name" : "TECHNETIUM (43), TC-96M"
  },
  {
    "name" : "TECHNETIUM (43), TC-97"
  },
  {
    "name" : "TECHNETIUM (43), TC-97M"
  },
  {
    "name" : "TECHNETIUM (43), TC-98"
  },
  {
    "name" : "TECHNETIUM (43), TC-99"
  },
  {
    "name" : "TECHNETIUM (43), TC-99M"
  },
  {
    "name" : "TELLURIUM (52), TE-121"
  },
  {
    "name" : "TELLURIUM (52), TE-121M"
  },
  {
    "name" : "TELLURIUM (52), TE-123M"
  },
  {
    "name" : "TELLURIUM (52), TE-125M"
  },
  {
    "name" : "TELLURIUM (52), TE-127"
  },
  {
    "name" : "TELLURIUM (52), TE-127M"
  },
  {
    "name" : "TELLURIUM (52), TE-129M"
  },
  {
    "name" : "TELLURIUM (52), TE-131M"
  },
  {
    "name" : "TELLURIUM (52), TE-132"
  },
  {
    "name" : "TERBIUM (65), TB-157"
  },
  {
    "name" : "TERBIUM (65), TB-158"
  },
  {
    "name" : "TERBIUM (65), TB-160"
  },
  {
    "name" : "THALLIUM (81), TI-200"
  },
  {
    "name" : "THALLIUM (81), TI-201"
  },
  {
    "name" : "THALLIUM (81), TI-202"
  },
  {
    "name" : "THALLIUM (81), TI-204"
  },
  {
    "name" : "THORIUM (90), TH (NAT)"
  },
  {
    "name" : "THORIUM (90), TH-227"
  },
  {
    "name" : "THORIUM (90), TH-228"
  },
  {
    "name" : "THORIUM (90), TH-229"
  },
  {
    "name" : "THORIUM (90), TH-230"
  },
  {
    "name" : "THORIUM (90), TH-231"
  },
  {
    "name" : "THORIUM (90), TH-232"
  },
  {
    "name" : "THORIUM (90), TH-234"
  },
  {
    "name" : "THULIUM (69), TM-167"
  },
  {
    "name" : "THULIUM (69), TM-170"
  },
  {
    "name" : "THULIUM (69), TM-171"
  },
  {
    "name" : "TIN (50), SN-113"
  },
  {
    "name" : "TIN (50), SN-117M"
  },
  {
    "name" : "TIN (50), SN-119M"
  },
  {
    "name" : "TIN (50), SN-121M"
  },
  {
    "name" : "TIN (50), SN-123"
  },
  {
    "name" : "TIN (50), SN-125"
  },
  {
    "name" : "TIN (50), SN-126"
  },
  {
    "name" : "TITANIUM (22), TI-44"
  },
  {
    "name" : "TRITIUM (1), T (H-3)"
  },
  {
    "name" : "TUNGSTEN (74), W-178"
  },
  {
    "name" : "TUNGSTEN (74), W-181"
  },
  {
    "name" : "TUNGSTEN (74), W-185"
  },
  {
    "name" : "TUNGSTEN (74), W-187"
  },
  {
    "name" : "TUNGSTEN (74), W-188"
  },
  {
    "name" : "URANIUM (92), U (DEP)"
  },
  {
    "name" : "URANIUM (92), U (ENRICHED TO 20 % OR LESS)"
  },
  {
    "name" : "URANIUM (92), U (NAT)"
  },
  {
    "name" : "URANIUM (92), U-230 (FAST LUNG ABSORBTION)"
  },
  {
    "name" : "URANIUM (92), U-230 (MEDIUM LUNG ABSORBTION)"
  },
  {
    "name" : "URANIUM (92), U-230 (SLOW LUNG ABSORBTION)"
  },
  {
    "name" : "URANIUM (92), U-232 (FAST LUNG ABSORBTION)"
  },
  {
    "name" : "URANIUM (92), U-232 (MEDIUM LUNG ABSORBTION)"
  },
  {
    "name" : "URANIUM (92), U-232 (SLOW LUNG ABSORBTION)"
  },
  {
    "name" : "URANIUM (92), U-233 (FAST LUNG ABSORBTION)D)"
  },
  {
    "name" : "URANIUM (92), U-233 (MEDIUM LUNG ABSORBTION)"
  },
  {
    "name" : "URANIUM (92), U-233 (SLOW LUNG ABSORBTION)F)"
  },
  {
    "name" : "URANIUM (92), U-234 (FAST LUNG ABSORBTION)D)"
  },
  {
    "name" : "URANIUM (92), U-234 (MEDIUM LUNG ABSORBTION)"
  },
  {
    "name" : "URANIUM (92), U-234 (SLOW LUNG ABSORBTION LONG)"
  },
  {
    "name" : "URANIUM (92), U-235 (ALL LUNG ABSORBTION TYPES)"
  },
  {
    "name" : "URANIUM (92), U-236 (FAST LUNG ABSORBTION)D)"
  },
  {
    "name" : "URANIUM (92), U-236 (MEDIUM LUNG ABSORBTION)"
  },
  {
    "name" : "URANIUM (92), U-236 (SLOW LUNG ABSORBTIONONG)F)"
  },
  {
    "name" : "URANIUM (92), U-238 (ALL LUNG ABSORBTION TYPES)"
  },
  {
    "name" : "VANADIUM (23), V-48"
  },
  {
    "name" : "VANADIUM (23), V-49"
  },
  {
    "name" : "XENON (54), XE-122"
  },
  {
    "name" : "XENON (54), XE-123"
  },
  {
    "name" : "XENON (54), XE-127"
  },
  {
    "name" : "XENON (54), XE-131M"
  },
  {
    "name" : "XENON (54), XE-133"
  },
  {
    "name" : "XENON (54), XE-135"
  },
  {
    "name" : "YTTERBIUM (70), YB-169"
  },
  {
    "name" : "YTTERBIUM (70), YB-175"
  },
  {
    "name" : "YTTRIUM (39), Y-87"
  },
  {
    "name" : "YTTRIUM (39), Y-88"
  },
  {
    "name" : "YTTRIUM (39), Y-90"
  },
  {
    "name" : "YTTRIUM (39), Y-91"
  },
  {
    "name" : "YTTRIUM (39), Y-91M"
  },
  {
    "name" : "YTTRIUM (39), Y-92"
  },
  {
    "name" : "YTTRIUM (39), Y-93"
  },
  {
    "name" : "ZINC (30), ZN-65"
  },
  {
    "name" : "ZINC (30), ZN-69"
  },
  {
    "name" : "ZINC (30), ZN-69M"
  },
  {
    "name" : "ZIRCONIUM (40), ZR-88"
  },
  {
    "name" : "ZIRCONIUM (40), ZR-93"
  },
  {
    "name" : "ZIRCONIUM (40), ZR-95"
  },
  {
    "name" : "ZIRCONIUM (40), ZR-97"
  }
]
